import React from 'react';

const Navbar = () => {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light p-3">
        <div className="container">
          {/* Brand Name on the Left */}
          <a className="navbar-brand fw-bold" href="/"> <span className="brand-DARK">UTTARAKNAND</span> <span className="brand-bold">UNIVERSITIES</span></a>

          {/* Toggler for responsive view */}
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Right Side Content */}
          <div className="collapse navbar-collapse justify-content-end" id="navbarContent">
            <div className="d-flex align-items-center gap-3">
              {/* Call Button */}
              <a href="tel:+918449669536" className="btn btn-outline-primary shadow-sm">
                Call Us
              </a>
              {/* Email Address */}
              <a href="mailto:info@uttarakhanduniversities.in" className="btn btn-outline-primary shadow-sm">
              info@uttarakhanduniversities.in
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
